import { SelectionEnum } from "../../enums";
import { Log } from "../../helpers";
import { DateYMDString } from "../../models";
import { selectedCellsBookingCalendarAtom } from "../atoms";
import { boundedSelectorFamily } from "../selector-factories";
import { bookingCalendarDataSelector } from "./booking.calendar.all-cells.selectors";

export const wholeRowSelectedBookingCalendarSF = boundedSelectorFamily<
  SelectionEnum,
  number
>({
  key: "wholeRowSelectedBookingCalendarSF",
  get:
    passengerId =>
    ({ get }) => {
      const { rows } = get(bookingCalendarDataSelector);
      const selectedCellsIds = get(selectedCellsBookingCalendarAtom);

      const row = rows.get(passengerId);

      if (!row) {
        return SelectionEnum.None;
      }

      if (!selectedCellsIds.size) {
        return SelectionEnum.None;
      }

      let isAllRowSelected = true;
      let isSomeCellInRowSelected = false;

      row.forEach(bookingCellId => {
        if (selectedCellsIds.has(bookingCellId)) {
          isSomeCellInRowSelected = true;
        } else {
          isAllRowSelected = false;
        }
      });

      if (isAllRowSelected) {
        return SelectionEnum.All;
      }

      return isSomeCellInRowSelected ? SelectionEnum.Some : SelectionEnum.None;
    },
});

export const wholeColumnSelectedBookingCalendarSF = boundedSelectorFamily<
  SelectionEnum,
  DateYMDString
>({
  key: "wholeColumnSelectedBookingCalendarSF",
  get:
    date =>
    ({ get }) => {
      const { cols } = get(bookingCalendarDataSelector);
      const selectedCellsIds = get(selectedCellsBookingCalendarAtom);

      const col = cols.get(date);

      if (!col) {
        Log.debug(
          `Cached data 'bookingCalendarDataSelector' has no such date: ${date}`,
        );
        return SelectionEnum.None;
      }

      if (!selectedCellsIds.size) {
        return SelectionEnum.None;
      }

      let isAllRowSelected = true;
      let isSomeCellInRowSelected = false;

      col.forEach(bookingCellId => {
        if (selectedCellsIds.has(bookingCellId)) {
          isSomeCellInRowSelected = true;
        } else {
          isAllRowSelected = false;
        }
      });

      if (isAllRowSelected) {
        return SelectionEnum.All;
      }

      return isSomeCellInRowSelected ? SelectionEnum.Some : SelectionEnum.None;
    },
});
